/**
 * Shared SVG filter definitions for the molten material.
 * Mounted exactly once at app root. Renders nothing visible.
 *
 * feTurbulence + feDisplacementMap produce the liquid refraction;
 * the two offset flood layers produce chromatic dispersion at the
 * edges, which is what makes glass read as a lens rather than a blur.
 */
export default function GlassDefs() {
  return (
    <svg aria-hidden="true" focusable="false"
         style={{ position: 'absolute', width: 0, height: 0, pointerEvents: 'none' }}>
      <defs>
        <filter id="foundry-dispersion" x="-20%" y="-20%" width="140%" height="140%">
          <feTurbulence type="fractalNoise" baseFrequency="0.008 0.012"
                        numOctaves="2" seed="7" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="7"
                             xChannelSelector="R" yChannelSelector="G" result="displaced" />
          <feOffset in="displaced" dx="1" dy="0" result="rShift" />
          <feOffset in="displaced" dx="-1" dy="0" result="bShift" />
          <feBlend in="rShift" in2="bShift" mode="screen" result="dispersed" />
          <feComposite in="dispersed" in2="SourceGraphic" operator="atop" />
        </filter>
      </defs>
    </svg>
  );
}
